<div class="bg-white rounded-2xl shadow-xl w-full max-w-xl grid grid-cols-1 overflow-hidden">
  <div class="p-16 flex flex-col justify-center">
    <div class="mb-8 flex justify-between">
      <h1 class="text-3xl font-semibold" style="color: #29709f">Change Password</h1>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="error" class="text-red-500 mb-4 text-center">{{ error }}</div>

    <form [formGroup]="form" (ngSubmit)="changePassword()" class="space-y-3">
      <!-- Old Password -->
      <span class="block text-xs text-gray-600 mt-1">Old Password</span>
      <div class="relative">
        <input
          [type]="showPassword ? 'text' : 'password'"
          formControlName="oldPassword"
          placeholder="Enter your old password"
          class="w-full text-sm px-3 py-2.5 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#216a86] focus:ring-opacity-30 placeholder-gray-400 pr-10 shadow-sm"
          autocomplete="current-password"
        />
        <button
          type="button"
          (click)="togglePassword()"
          aria-label="Toggle password visibility"
          class="absolute right-2 top-2.5 inline-flex items-center justify-center h-7 w-7 rounded-full bg-white border border-gray-200 shadow-sm hover:scale-105 transition-transform"
        >
          <svg
            *ngIf="!showPassword"
            class="w-4 h-4 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <svg
            *ngIf="showPassword"
            class="w-4 h-4 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M3 3l18 18"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M9.88 9.88A3 3 0 0114.12 14.12"
            />
          </svg>
        </button>
      </div>
      <div
        *ngIf="form.get('oldPassword')?.touched && form.get('oldPassword')?.invalid"
        class="text-red-500 text-xs"
      >
        <div *ngIf="form.get('oldPassword')?.errors?.['required']">Old Password is required.</div>
      </div>

      <!-- New Password -->
      <span class="block text-xs text-gray-600 mt-1">New Password</span>
      <div class="relative">
        <input
          [type]="showPassword0 ? 'text' : 'password'"
          formControlName="newPassword"
          placeholder="Enter your new password (minimum 8 characters)"
          class="w-full text-sm px-3 py-2.5 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#216a86] focus:ring-opacity-30 placeholder-gray-400 pr-10 shadow-sm"
          autocomplete="current-password"
        />
        <button
          type="button"
          (click)="togglePassword0()"
          aria-label="Toggle password visibility"
          class="absolute right-2 top-2.5 inline-flex items-center justify-center h-7 w-7 rounded-full bg-white border border-gray-200 shadow-sm hover:scale-105 transition-transform"
        >
          <svg
            *ngIf="!showPassword0"
            class="w-4 h-4 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <svg
            *ngIf="showPassword0"
            class="w-4 h-4 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M3 3l18 18"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M9.88 9.88A3 3 0 0114.12 14.12"
            />
          </svg>
        </button>
      </div>
      <div
        *ngIf="form.get('newPassword')?.touched && form.get('newPassword')?.invalid"
        class="text-red-500 text-xs"
      >
        <div *ngIf="form.get('newPassword')?.errors?.['required']">New Password is required.</div>
      </div>

      <!-- Confirm Password -->
      <span class="block text-xs text-gray-600 mt-1">Confirm Password</span>
      <div class="relative">
        <input
          [type]="showPassword1 ? 'text' : 'password'"
          formControlName="confirmPassword"
          placeholder="Confirm your new password"
          class="w-full text-sm px-3 py-2.5 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#216a86] focus:ring-opacity-30 placeholder-gray-400 pr-10 shadow-sm"
          autocomplete="current-password"
        />
        <button
          type="button"
          (click)="togglePassword1()"
          aria-label="Toggle password visibility"
          class="absolute right-2 top-2.5 inline-flex items-center justify-center h-7 w-7 rounded-full bg-white border border-gray-200 shadow-sm hover:scale-105 transition-transform"
        >
          <svg
            *ngIf="!showPassword1"
            class="w-4 h-4 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <svg
            *ngIf="showPassword1"
            class="w-4 h-4 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M3 3l18 18"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M9.88 9.88A3 3 0 0114.12 14.12"
            />
          </svg>
        </button>
      </div>
      <div *ngIf="form.get('confirmPassword')?.errors?.['mismatch']" class="text-red-500 text-xs">
        Passwords do not match.
      </div>

      <div
        *ngIf="form.get('confirmPassword')?.touched && form.get('confirmPassword')?.invalid"
        class="text-red-500 text-xs"
      >
        <div *ngIf="form.get('confirmPassword')?.errors?.['required']">Confirm Password is required.</div>
      </div>

      <button
        type="submit"
        [disabled]="loading"
        class="w-full mt-3 inline-flex items-center justify-center gap-2 text-sm font-semibold py-2.5 rounded-lg text-white transition-transform transform hover:-translate-y-[1px] shadow-sm"
        style="background: linear-gradient(90deg, #1f6a82, #2a91ae)"
      >
        <svg
          *ngIf="!loading"
          class="w-4 h-4 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M5 12h14M12 5l7 7-7 7"
          />
        </svg>
        <svg
          *ngIf="loading"
          class="animate-spin w-4 h-4 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
        </svg>
        <span>{{ loading ? 'Changing Password...' : 'Change Password' }}</span>
      </button>
    </form>
  </div>
</div>
